import React from 'react';
import './multiInput.scss';

const SubtractIcon = ({ index, arrayHelpers }) => (
    <i className="fas fa-minus button-icon" onClick={() => arrayHelpers.remove(index)} />
);

export default SubtractIcon;
